export type StationDetailsEvent =
  | { kind: 'opened'; stationId: string }
  | { kind: 'transferTapped'; fromId: string; toId: string }
  | { kind: 'favoriteTapped'; stationId: string; toState: boolean }
  | { kind: 'paywallTapped'; stationId: string }
  | { kind: 'reportIssueTapped'; stationId: string }
  | { kind: 'timetableUpsellShown'; stationId: string }

interface AnalyticsEvent {
  name: string
  parameters: Record<string, string | number | boolean>
}

type Reporter = (event: AnalyticsEvent) => void

export function reportStationDetailsEvent(reporter: Reporter, event: StationDetailsEvent): void {
  switch (event.kind) {
    case 'opened':
      reporter({ name: 'station_details_opened', parameters: { station_id: event.stationId } })
      return
    case 'transferTapped':
      reporter({
        name: 'station_details_transfer_tapped',
        parameters: { from_id: event.fromId, to_id: event.toId },
      })
      return
    case 'favoriteTapped':
      reporter({
        name: 'station_details_favorite_tapped',
        parameters: { station_id: event.stationId, to_state: event.toState },
      })
      return
    case 'paywallTapped':
      reporter({
        name: 'station_details_paywall_tapped',
        parameters: { station_id: event.stationId },
      })
      return
    case 'reportIssueTapped':
      // Cross-platform contract name (spec §8) — iOS + Android both emit
      // `station_details_report_tapped`. (Web previously emitted
      // `..._report_issue_tapped`; corrected to the shared contract.)
      reporter({
        name: 'station_details_report_tapped',
        parameters: { station_id: event.stationId },
      })
      return
    case 'timetableUpsellShown':
      // Restored V1 `station_details_timetable_upsell_banner_shown` signal,
      // re-namespaced to the V2 family. iOS fires it from the upsell
      // banner's `.onAppear` (non-premium only); web mirrors via a
      // useEffect when TimetableUpsellBanner mounts.
      reporter({
        name: 'station_details_timetable_upsell_shown',
        parameters: { station_id: event.stationId },
      })
      return
  }
}
